import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Link from '@material-ui/core/Link'
import { useMediaQuery } from '@material-ui/core'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PublishIcon from '@material-ui/icons/Publish';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import EditIcon from '@material-ui/icons/Edit';
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/Add'
import Button from '@material-ui/core/Button'
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import VisibilityIcon from '@material-ui/icons/Visibility';
import BlockIcon from '@material-ui/icons/Block';
import { convertUTCTimeZone } from '../../Helpers/basic'
import { style } from '../../Styles/theme'
import Pagination from '../ExternalAssignments/pagination'
import AssignmentPreview from '../Common/OpeningDialogView/assignmentPreview'
import AddAssessment from '../Assessments/addAssessment'
import DeleteAssessment from '../Assessments/confirmDialog'
import AssessmentPublish from './publishDialog'
import { deleAssessment } from '../../store/Assessments/actionCreator'
import { ERROR_DELETE_ASSESSMENT } from '../Common/Constants/errorMessages';
import { SUCCESS_DELETE_ASSESSMENT } from '../Common/Constants/successMessages';
import { showSnackBar } from '../../store/AlertMessages/actionCreator';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 'auto',
      marginTop: '10px',
      paddingLeft: '50px',
      paddingRight: '50px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    width: '100%'
  },
  titleWrapper: {
    fontSize: '29px',
    fontWeight: '500',
    color: style.fontColour._blue,
    marginBottom: '11px'
  },
  button: {
    flexGrow: 1,
    marginRight: '38px',
    backgroundColor: '#3098FF',
    color: '#FFFFFF',
    '&:hover': {
      backgroundColor: '#3098FF',
    },
  },
  iconWrapper: {
    color: style.fontColour._blue,
    fontSize: '23px',
    marginRight: '10px',
  },
  iconButtonWrapper: {
    color: '#2e8eec',
    marginTop: '10px'
  },
  dueDateWrapper: {
    color: '#2e8eec',
    textAlign: 'initial',
    fontSize: '12px',
    marginTop: '3px',
    marginBottom: '-7px'
  },
  dateWrapper: {
    color: '#999',
    textAlign: 'initial',
    fontSize: '12px',
    marginTop: '3px',
    marginBottom: '-7px'
  }
}));

function AssignmentsListView(props) {
  const classes = useStyles()
  const maxWidth700 = useMediaQuery('(max-width:700px)');
  const assessmentData = props && props.assessmentData && props.assessmentData.length ? props.assessmentData : []

  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [openPreview, setOpenPreview] = React.useState(false)
  const [previewDetails, setPreviewDetails] = React.useState([])
  const [openEditAssessment, setOpenEditAssessment] = React.useState(false)
  const [openDeleteConfirm, setOpenDeleteConfirm] = React.useState(false)
  const [openPublishPopup, setOpenPublishPopup] = React.useState(false)
  const [openUnPublishPopup, setOpenUnpublishPopup] = React.useState(false)
  const [selectedAssessmentId, setSelectedAssessmentId] = React.useState();

  const onAssignmentClick = assessmentData => {
    props.history.push(`externalassessments/${assessmentData.id}`)
  }

  const onPreviewTrigger = (data) => {
    setPreviewDetails(data)
    setOpenPreview(true)
  }
  const closeAssignmentPreivew = () => {
    setOpenPreview(false)
    setPreviewDetails([])
  }

  const triggerAssessmentEdit = (data) => {
    setPreviewDetails(data)
    setSelectedAssessmentId(data && data.id)
    setOpenEditAssessment(true)
  }
  const closeAssessmentEdit = () => {
    setOpenEditAssessment(false)
    setPreviewDetails([])
  }

  const onDeleteTrigger = (data) => {
    setPreviewDetails(data)
    setOpenDeleteConfirm(true)
  }
  const closeDeleteDialog = () => {
    setOpenDeleteConfirm(false)
    setPreviewDetails([])
  }

  const onPublishTrigger = (data) => {
    setPreviewDetails(data)
    setOpenPublishPopup(true)
  }

  const closePublish = () => {
    setPreviewDetails([])
    setOpenPublishPopup(false)
  }

  const onUnPublishTrigger = (data) => {
    setPreviewDetails(data)
    setOpenUnpublishPopup(true)
  }

  const closeUnpublish = () => {
    setPreviewDetails([])
    setOpenUnpublishPopup(false)
  }

  const successDeleteCallBack = res => {
    setSubmitLoader(false)
    props.showSnackBar(
    {
      state: true,
      message: SUCCESS_DELETE_ASSESSMENT,
      type: 'success'
    })
    setOpenDeleteConfirm(false)
    setPreviewDetails([])
    props.listAllAssessment()
  }
  //FOR DELETE API CALL
  const onAggreeDeleteDialog = assessment => {
    setSubmitLoader(true)
    deleAssessment({
      assessment_id: assessment.id
    },
    successDeleteCallBack,
    error => {
      setSubmitLoader(false)
      props.showSnackBar(
      {
        state: true,
        message: ERROR_DELETE_ASSESSMENT,
        type: 'error'
      })
      setPreviewDetails([])
    }
    )
  }

  const dateFormat = (due_days) => {
    if(due_days){
      return(`Due Date:${convertUTCTimeZone(due_days)}`)
    }
  }

  return(
    <div className={classes.root}>
      <a className="skip-main" href="#leftMenu">
        Back to main menu
      </a>
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          { !openEditAssessment ? (
            <Paper className={classes.paper}>
              <Typography className={classes.titleWrapper} aria-hidden="true">Assessments</Typography>
              <Divider style={{ marginBottom: '20px'}} aria-hidden="true"/>
              <div id="mainH1Tag" tabIndex="-1" className="accessibility">
                <h1>My Assessments listing view</h1>
              </div>
              { assessmentData && assessmentData.length ? (
                <React.Fragment>
                  <List style={{ paddingLeft: !maxWidth700 ? '41px' : '', paddingRight: !maxWidth700 ? '41px' : ''}}>
                    {assessmentData && assessmentData.map((data, index)=>(
                      <React.Fragment key={index}>
                        <ListItem>
                          <AssignmentTurnedInIcon className={classes.iconWrapper}/>
                          <Grid item sm={12} xs={12} md={10} lg={10}>
                            { data.published === true ? (
                              <div>
                                <React.Fragment>
                                  <Link component="button" style={{ cursor: 'pointer' }} onClick={() => {onAssignmentClick(data)}}>
                                    <Typography style={{ fontSize: '14px', color: '#2e8eec', fontWeight: 600 }}>{data.title ? data.title : null}</Typography>
                                  </Link>
                                  <Grid container spacing={1}>
                                    <Grid item sm={4} xs={6} >
                                      <p className={classes.dueDateWrapper}>
                                        {dateFormat(data.due_date)} | {`${data.test_type} Test`} | { data.percent }%
                                      </p>
                                    </Grid>
                                    <Grid item sm={4} xs={6} >
                                      { data.published === true ? (
                                        <Tooltip title="Published">
                                          <CheckCircleIcon style={{ fontSize: '21px', color: '#4caf50' }}/>
                                        </Tooltip>
                                      ) : null }
                                    </Grid>
                                  </Grid>
                                </React.Fragment>
                              </div>
                            ) : (
                              <React.Fragment>
                                <Typography style={{ fontSize: '14px', color: '#999', fontWeight: 600 }}>{ data.title ? data.title : null }</Typography>
                                <p className={classes.dateWrapper}>
                                  {dateFormat(data.due_date)} | {`${data.test_type} test`} | { data.percent }%
                                </p>
                              </React.Fragment>
                            )}
                          </Grid>
                          <Grid item sm={12} xs={12} md={2} lg={2}>
                            <div>
                              <Tooltip title="Preview">
                                <IconButton onClick={() => {onPreviewTrigger(data)}} className={classes.iconButtonWrapper}>
                                  <VisibilityIcon style={{ fontSize: 17 }}/>
                                </IconButton>
                              </Tooltip>
                              { data.published === false ? (
                                <Tooltip title="Edit">
                                  <IconButton onClick={() => {triggerAssessmentEdit(data)}} className={classes.iconButtonWrapper}>
                                    <EditIcon style={{ fontSize: 17 }}/>
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <IconButton disabled={data.published} className={classes.iconButtonWrapper}>
                                  <EditIcon style={{ fontSize: 17 }}/>
                                </IconButton>
                              )}
                              <Tooltip title="Delete">
                                <IconButton onClick={() => {onDeleteTrigger(data)}} className={classes.iconButtonWrapper} >
                                  <DeleteIcon style={{ fontSize: 17 }}/>
                                </IconButton>
                              </Tooltip>
                              { data.published === false ? (
                                <Tooltip title="Publish">
                                  <IconButton onClick={() => {onPublishTrigger(data)}} className={classes.iconButtonWrapper}>
                                    <PublishIcon style={{ fontSize: 17 }}/>
                                  </IconButton>
                                </Tooltip>
                              ) : (
                                <Tooltip title="Unpublish">
                                  <IconButton onClick={() => {onUnPublishTrigger(data)}} className={classes.iconButtonWrapper}>
                                    <BlockIcon style={{ fontSize: 17 }}/>
                                  </IconButton>
                                </Tooltip>
                              )}
                            </div>
                          </Grid>
                        </ListItem>
                        <Divider aria-hidden="true"/>
                      </React.Fragment>
                    ))}
                  </List>
                  { props && props.totalCount > 10 ? (
                    <Pagination onPagination={props.onPaginationHit} enableRowsPerPage={false} page={props.page} rowsPerPage={props.rowsPerPage} totalCount={props.totalCount}/>
                  ) : null }
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                    <Typography style={{ marginTop: '12px', color: '#546e7a'}}>Please click button to create assessment and get started</Typography>
                    <Typography style={{ fontSize: '13px', marginTop: '3px', marginBottom: '21px', color: '#9e9e9e', fontWeight: '500'}}>Assessments you created will show up here.</Typography>
                  </div>
                  <Button
                    variant="contained"
                    className={classes.button}
                    startIcon={<AddIcon />}
                    onClick={props.triggerAddAssessment}
                  >
                    <Divider orientation="vertical" flexItem style={{ marginRight: '10px', backgroundColor: '#bdbdbd'}} aria-hidden="true"/>
                    Assessment
                  </Button>
                </React.Fragment>
              )}
            </Paper>
          ) : null }
        </Grid>
      </Grid>
      { openPreview ? (
        <AssignmentPreview
          openPreview={openPreview}
          closeAssignmentPreivew={closeAssignmentPreivew}
          previewDetails={previewDetails}
          fromType="assessment"
        />
      ) : null }
      { openEditAssessment ? (
        <div style={{ marginTop: '-73px'}}>
          <AddAssessment
            cancelAddAssessment={closeAssessmentEdit}
            listAllAssessment={props.listAllAssessment}
            history={props.history} 
            match={props.match}
            assessmentData={previewDetails}
            selectedAssessmentId={selectedAssessmentId}
            from='externalType'
            clickType='editBtnClick'
          />
        </div>
      ) : null }
      { openDeleteConfirm ? (
        <DeleteAssessment
          history={props.history}
          match={props.match}
          assessment={previewDetails}
          onCloseDeleteDialog={closeDeleteDialog}
          onAggreeDeleteDialog={onAggreeDeleteDialog}
          loader={submitLoader}
          open={openDeleteConfirm}
        />
      ) : null }
      { openPublishPopup ? (
        <AssessmentPublish
          match={props.match}
          history={props.history}
          listAllAssessment={props.listAllAssessment}
          assessmentDetails={previewDetails}
          openPublishPopup={openPublishPopup}
          closePublish={closePublish}
          from='externalType'
        />
      ) : null }
      { openUnPublishPopup ? (
        <AssessmentPublish
          match={props.match}
          history={props.history}
          listAllAssessment={props.listAllAssessment}
          assessmentDetails={previewDetails}
          openMode='unPublish'
          from='externalType'
          openUnPublishPopup={openUnPublishPopup}
          closeUnpublish={closeUnpublish}
        />
      ) : null }
    </div>
  )
}

const mapStateToProps = state => {
  return {}
}
export default connect(
  mapStateToProps, { showSnackBar }
)(AssignmentsListView);